export default __webpack_public_path__ + "static/rpa-automation-procurement-3e944d7c3b94b6ccb36cb9759abf6916.png";